<script>
  import { navigate } from "svelte-navigator";
  import { _ } from 'svelte-i18n';

  import './i18n';
  
  export let meters;
  
  const handleOnSubmit = () => {
    if (meters) {
      navigate(`/m/${meters}`);
    }
  };
</script>

<form class="meters-form" on:submit={handleOnSubmit}>
  <label class="meters-field meters-label" for="meters-input">
   {$_('home.meters')}
  </label>
  <div class="meter-tie-up">
    <input id="meters-input" type="number" class="meters-input" step="any" bind:value={meters} required min="0" />
    <button type="submit" class="meters-submit">{$_('home.convert')}</button>
  </div>
</form>